<template>
  <div>
    <custom-table
      ref="customTable"
      :columns="columns"
      :sums="sums"
      :custom-view="customView"
      api-url="/order/v1/list-partner"
      download-file-name="danh-sach-don-hang.xlsx"
      table-height="calc(100vh - 145px)"
      @downloadFile="downloadFile"
      @showDialogOrder="showDialogOrder"
    ></custom-table>
    <!-- api-download-url="/order/v1/list-export" -->

    <v-dialog v-model="orderDialog" max-width="480px">
      <DetailDialog
        v-if="orderDialog && order && order.id"
        :order="order"
        :is-show-card-payment="false"
        @close="hideDialogOrder"
      />
    </v-dialog>
  </div>
</template>

<script>
import { CUSTOM_VIEW, ORDER_STATUSES } from "@/libs/const";
import { httpClient } from "@/libs/http";

export default {
  name: "Partner",
  components: {
    DetailDialog: () => import("@/components/exchange/DetailDialog"),
  },
  data: () => ({
    columns: [],
    sums: [],
    customView: CUSTOM_VIEW.ORDER_LIST,
    taxStatusOptions: [],
    sourceOptions: [],
    ceOptions: [],
    billOptions: [],
    yesNoOptions: [],
    orderDialog: false,
  }),
  created() {
    const columns = [
      {
        type: "date-range-filter",
        label: this.$t("Thời gian"),
        placeholder: this.$t("Thời gian"),
        name: "created_at",
        hasSort: false,
        sortName: "created_at",
        key: "created_at",
        required: true,
        defaultValue: [],
      },
      {
        type: "input-filter",
        label: this.$t("Tracking"),
        placeholder: this.$t("Tracking"),
        name: "tracking_id",
        hasSort: false,
        sortName: "tracking_id",
        key: "tracking_id",
        required: true,
        action: "showDialogOrder",
      },
      {
        type: "select-filter",
        label: this.$t("Trạng thái"),
        placeholder: this.$t("Trạng thái"),
        name: "status",
        hasSort: false,
        sortName: "status",
        key: "status",
        options: [...ORDER_STATUSES],
        required: true,
      },
      {
        type: "input-filter",
        label: this.$t("Khách hàng"),
        placeholder: this.$t("Khách hàng"),
        name: "customer_name",
        hasSort: false,
        sortName: "customer_name",
        key: "customer_name",
        required: true,
      },
      {
        type: "input-filter",
        label: this.$t("Kênh LL"),
        placeholder: this.$t("Kênh LL"),
        name: "contact_channel_name",
        hasSort: false,
        sortName: "contact_channel_name",
        key: "contact_channel_name",
        required: true,
      },
      {
        type: "input-filter",
        label: this.$t("T. Tin"),
        placeholder: this.$t("T. Tin"),
        name: "customer_contact_name",
        hasSort: false,
        sortName: "customer_contact_name",
        key: "customer_contact_name",
        required: true,
        component: "QrLink",
      },
      /* {
        type: "input-filter-from-to",
        label: this.$t("Thu dịch vụ"),
        placeholder: this.$t("Thu dịch vụ"),
        name: "service_amount",
        hasSort: false,
        sortName: "service_amount",
        key: "service_amount",
        required: true,
      }, */
      {
        type: "input-filter-from-to",
        label: this.$t("Hoa hồng"),
        placeholder: this.$t("Hoa hồng"),
        name: "commission",
        hasSort: false,
        sortName: "commission",
        key: "commission",
        required: true,
      },
      {
        type: "input-filter",
        label: this.$t("Mã xe"),
        placeholder: this.$t("Mã xe"),
        name: "asset_uid_name",
        hasSort: false,
        sortName: "asset_uid_name",
        key: "asset_uid_name",
        required: true,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Sạc"),
        placeholder: this.$t("Sạc"),
        name: "count_charger",
        hasSort: false,
        sortName: "count_charger",
        key: "count_charger",
        required: true,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Mũ"),
        placeholder: this.$t("Mũ"),
        name: "count_helmet",
        hasSort: false,
        sortName: "count_helmet",
        key: "count_helmet",
        required: true,
      },
    ];
    this.columns = [...columns];

    const sums = [
      {
        text: "Đơn hàng",
        key: "total",
      },
      /* {
        text: "Thu dịch vụ",
        key: "service_amount",
      }, */
      {
        text: "Hoa hồng",
        key: "commission",
      },
    ];
    this.sums = [...sums];
  },
  methods: {
    async showDialogOrder(order) {
      const { data } = await httpClient.post("/order/v1/get-detail", {
        id_order: order.id,
      });
      this.order = { ...data };
      this.orderDialog = true;
    },

    hideDialogOrder() {
      this.order = {};
      this.orderDialog = false;
    },

    downloadFile(item) {
      const filenameSplit = item.file.split("/");
      const filename = filenameSplit[filenameSplit.length - 1];
      this.downloadExcelFile(
        "/download-export-excel-file",
        { filename: item.file },
        filename
      );
    },
  },
};
</script>
